import api from '../api/axios';

export interface ContactGroup {
  id?: number;
  name: string;
  description?: string;
  contacts?: any[];
  color?: string;
  isActive?: boolean;
  tags?: string[];
}

const ContactGroupService = {
  getAll: (params?: any) => api.get('/contact-groups', { params }),
  getOne: (id: number) => api.get(`/contact-groups/${id}`, { params: { populate: '*' } }),
  create: (data: ContactGroup) => api.post('/contact-groups', { data }),
  update: (id: number, data: Partial<ContactGroup>) => api.put(`/contact-groups/${id}`, { data }),
  delete: (id: number) => api.delete(`/contact-groups/${id}`),
  
  // Import contacts from file
  importContacts: (groupId: number, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('groupId', groupId.toString());
    
    return api.post(`/contact-groups/${groupId}/import-contacts`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default ContactGroupService;

